// extracted by mini-css-extract-plugin
export var emailBlockLink = "_go-0";